import React from 'react';
import '../../css/ComingSoon.css';

function ComingSoon() {
  return (
      <div className="comingSoonContainer">
          <h1>Coming Soon!</h1>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it</p>
      </div>
  );
}

export default ComingSoon;
